import { createFileRoute } from "@tanstack/react-router";

/**
 * Index route for the Learn hub.
 *
 * The hub UI itself is rendered by the `/learn` layout, but the canonical and
 * og:url tags live here so the layout never concatenates a `/learn` canonical
 * onto every `/learn/*` child page (TanStack merges `meta` but concatenates
 * `links`).
 */
export const Route = createFileRoute("/learn/")({
  head: () => ({
    meta: [
      { property: "og:url", content: "https://recoverytrauma.com/learn" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/learn" }],
  }),
  component: () => null,
});
